<script lang="ts">
    import { appManager } from "../AppManagerStore";
    import { _, locale } from "svelte-i18n";
    import type { ModelInfo } from "./ModelInfo";

    export let info: ModelInfo;
    export let size: "big" | "small" = "big";
    let url: string = "";
    $: if (typeof info !== "undefined") {
        url = `${$appManager.PublicUrl}map/model/${info.id}`;
    }
</script>

<div class="col-md-{size == "big" ? "12" : "6"} col-12 d-flex mb-4 mt-4">
    <div
        class="card text-reset text-decoration-none shadow-extra-dark-lg mb-6 mb-xl-0 overlay overlay-30 bg-cover promoted-post"
        style="background-image: linear-gradient(to bottom, rgba(0, 0, 0, 0),rgba(0, 0, 0, 0),rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.4)), url({$appManager.PublicUrl}{info.image});">
        <div class="position-relative card-body d-flex flex-column">
            <p>
                {#each info.tags as tag}
                    <span class="badge bg-light me-1"
                        >{$_(`models.tags.${tag}`)}</span>
                {/each}
            </p>

            <h1 class="text-white mt-auto">
                <a class="text-white no-underline" href={url} target="_blank"
                    >{$_(`models.${info.localizationKey}.title`)}</a>
            </h1>

            <p class="text-white mb-5">
                <a class="text-white no-underline" href={url} target="_blank"
                    >{$_(`models.${info.localizationKey}.tagline`)}</a>
            </p>

            <div class="row pt-5 border-top border-white-20">
                <div class="col">
                    <h6 class="text-uppercase text-white mb-0">
                        {info.type}
                    </h6>
                </div>
                <div class="col-auto">
                    <p class="h6 text-uppercase text-white mb-0">
                        {#each info.vehicles as vehicle}
                        <span class="me-1">
                            {$_(`models.vehicles.${vehicle}`)}</span>
                        {/each}
                    </p>
                </div>
            </div>
        </div>
    </div>
</div>

<style>
    .promoted-post {
        height: 600px;
    }

    .position-relative {
        position: relative !important;
        height: 100%;
    }

    .shadow-extra-dark-lg {
        box-shadow: 0 1.5rem 4rem rgba(22, 28, 45, 0.5) !important;
    }
</style>
